const TRACKING_PARAMS = ['utm_campaign','utm_source','utm_medium','_hsenc']

export const stripTrackingParams = (href: string) => {
    return removeUrlParameters(href, TRACKING_PARAMS);
}

function removeUrlParameters(url: string, paramsToRemove: string[]): string {
  try {
    const urlObj = new URL(url);
    const searchParams = urlObj.searchParams;
    paramsToRemove.forEach(param => searchParams.delete(param));
    return urlObj.toString();
  } catch (error) {
    return url;
  }
}